import React, { useEffect, useState, useRef } from 'react';
import { Avatar, Badge, Breadcrumb, Button, Card, Checkbox, Col, Divider, Drawer, Dropdown, Flex, Pagination, Form, Grid, Input, Layout, List, message, Popconfirm, Row, Select, Steps, Table, Tabs, Tag, theme, Typography, Upload } from 'antd';
import { AppstoreOutlined, UserOutlined, AntDesignOutlined, CloseOutlined, MoreOutlined, EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import COLOR from './../../../theme/constant/COLOR';
import { useSelector } from 'react-redux';
import RequestApproval from '../../../restAPI/RequestApproval';
import CreateTeam from './CreateTeam';
import CommonSkeletonLoader from '../../../helperComponents/CommonSkeleton';

const { Option } = Select;
const { Text } = Typography;

const { useBreakpoint } = Grid

export default function CurrentTeams({ drawerClose, refreshfunc }) {
    const { companyId, token, userCompany, role } = useSelector(state => state.auth);
    const [selectedTeam, setSelectedTeam] = useState(null); // State to track the selected team
    const [selectedTeamScratch, setSelectedTeamScratch] = useState(null); // State to track the selected team
    const [companyTeams, setCompanyTeams] = useState([]);
    const [companyTeamsBackup, setCompanyTeamsBackup] = useState([]);
    const [paginatedItems, setPaginatedItems] = useState([]);
    const [teams, setTeams] = useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    const [teamEdit, setEditTeam] = useState(null)
    const [members, setMembers] = useState(null)
    const [hocUserLists, setHocUserLists] = useState({});
    const [teamsListLoading, setTeamsListLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const screens = useBreakpoint();

    const currentTeamRef = useRef(null);

    const { token: {
        colorBgContainer,
        colorBgSpotlight,
        colorPrimaryBorder,
        colorTextDescription,
        fontSizeSM,
        colorBgElevated,
        borderRadiusLG,
        colorBorder,
        colorTextPlaceholder,
        colorText,
        colorPrimary,
        colorWarning,
        colorError },
    } = theme.useToken();

    const pageSize = 10; // Number of items per page

    RequestApproval.testWithJWTandCID(companyId, token);

    useEffect(() => {
        setTeamsListLoading(true);
        getTeams();
    }, [companyId])


    const getTeams =() => {
            // console.log("Tem");setCompanyTeams
            const data = RequestApproval.getTeamsForCompany().then((data) => {
                let teams = []
                console.log(data.data,"data getall teams ffffffffffffffffff");
                data.data.forEach((element,index) => {
                    const keys = Object.keys(COLOR);
                    const randomKey = keys[Math.floor(Math.random() * keys.length)];
                    let obj = {
                        _id: element._id,
                        name: element.name,
                        type: element.circulationType,
                        color: element.circulationType=="hierarchy" ? 'orange':'green',
                        members:element.members.map((member)=>{
                            const mem = {
                                name : member.approverName.charAt(0).toUpperCase(),
                                color : COLOR[randomKey],
                                approverProfilePicture:member.approverProfilePicture
                            };

                        return mem;

                    })
                }
                teams.push(obj);
            });

            const paginadItems = teams.slice(0, 0 + pageSize);
            setPaginatedItems(paginadItems)

            setCompanyTeams(teams);
            setCompanyTeamsBackup(teams);
            setTeams(data.data);
            setTeamsListLoading(false)
            // console.log(data.data,"alllllllllllll teammmmmmmmmmmmmmmm")
        }).catch((error) => {
            setTeamsListLoading(false);
        });
    }
    const searchTemplate = (e, type) => {

        let teamsTemp = [...companyTeamsBackup]


        if (e !== "") {
            if (type === 110) {
                teamsTemp = teamsTemp.filter(element => element.type === e);
            }
            if (type === 120) {
                let searchvalue = e.replace(/^\s+/, "").toLowerCase();
                let regex = new RegExp(`${searchvalue}`);
                teamsTemp = teamsTemp.filter(element => regex.test(element.name.toLowerCase()));
            }
            setCompanyTeams(teamsTemp);
            setPaginatedItems(teamsTemp);
        } else {
            setCompanyTeams(companyTeamsBackup);
        }

    }

    const selectTeam = (team) => {



        const data = teams.filter(element => element._id === team._id);
        setSelectedTeam(team);
        // console.log(data[0],"selected team bbbbbbbbbbbbbbbbbbbbbb")
        // console.log(team,"selected team xxxxxxxxxxxxxxxxxxxxxxxxx")
        setSelectedTeamScratch(data[0]);

        const members = data[0].members.map((item, index) => {
            let obj = {
                key: index,
                approverId: item.approverId,
                name: item.approverName,
                hockUserId: item.hockUserId,
                actionOptions: item.permission,
                notificationPermissions: item.notification
            }
            return obj
        })

        setMembers(members);

        let teamState = {
            name: data[0].name,
            companyId: companyId,
            circulationType: data[0].circulationType,
            members: data[0].members.map((item, index) => {
                let obj = {
                    key: index,
                    branchId: item.branchId,
                    position: item.position,
                    approverId: item.approverId,
                    hockUserId: item.hockUserId,
                    permission: item.permission,
                    notification: item.notification
                }
                return obj
            })
        }
        setInitialHocUsers(data[0].members);
        setEditTeam(teamState)

        console.log(data[0], "selected team");
    }
    const onClose = () => {
        setOpenEdit(false);
    }
    const openEditDrawer = () => {
        setOpenEdit(true);
    }

    const setInitialHocUsers = async (Members) => {
        if (Members.length > 0) {

            for (const item of Members) {
                const hocusers = await gethocusersforId(item.approverId);
                setHocUserLists((prevHocUser) => ({
                    ...prevHocUser,   // Keep existing properties
                    [item.approverId]: hocusers,  // Dynamically add new property
                }))
            }

        }
    }
    const gethocusersforId = async (approverId) => {
        const data = await RequestApproval.getAddHocUsers(approverId)
            .then((response) => {
                const usersList = response.data.map((element) => ({
                    id: element.signatoriesId._id,
                    name: element.signatoriesId.name,
                }));
                return usersList;
            })
            .catch((error) => {
                console.error("Error fetching users:", error);
                return [] // Handle error by resetting users
            })

        return data
    }

    const saveEditTeamData = async () => {

        let status = false;
        status = await currentTeamRef.current.EditeTeam();
        if (status) {
            getTeams();
            setOpenEdit(false);
            setSelectedTeam(null);
            refreshfunc();

        }
    }

    const deleteTeambyId = async (team) => {
        try {
            await RequestApproval.deleteTeamById(team._id);
            message.success('Remove Team Successfully!');
            getTeams();
            refreshfunc();
        } catch (err) {
            if (err.response) {
                message.error(`${err.response.data.message}`);
            } else {
                message.error('Remove Team Failed!');
            }
        }
    }

    const drawerclosefun =()=>{
        getTeams();
        onClose();
    }
    
    const pagination = (currentPage) => {
        const startIndex = (currentPage - 1) * pageSize;
        const paginadItems = companyTeams.slice(startIndex, startIndex + pageSize);
        setCurrentPage(currentPage);
        setPaginatedItems(paginadItems)
    }

    // const teams = [
    //     {
    //         id: 1,
    //         name: 'Human Resource Team',
    //         type: 'Parellel',
    //         color: 'green',
    //         members: [
    //             { name: 'A', color: COLOR.alizarin },
    //             { name: 'K', color: COLOR.amethyst },
    //             { icon: <UserOutlined />, color: COLOR.asbestos },
    //             { icon: <AntDesignOutlined />, color: COLOR.belizeHole },
    //         ],
    //     },
    //     {
    //         id: 2,
    //         name: 'Marketing Team',
    //         type: 'Hierarchical',
    //         color: 'orange',
    //         members: [
    //             { name: 'A', color: COLOR.alizarin },
    //             { name: 'K', color: COLOR.amethyst },
    //             { icon: <UserOutlined />, color: COLOR.asbestos },
    //             { icon: <AntDesignOutlined />, color: COLOR.belizeHole },
    //         ],
    //     },
    // ];

    const dataSource = [
        {
            key: '1',
            actionOptions: ['Approve', 'View'], // Dropdown options for the action
            name: 'John Doe',                  // Name of the user
            userOptions: ['User A', 'User B', 'User C', 'User D', 'User E', 'Add Another'], // Dropdown options for the user
        },
        {
            key: '2',
            actionOptions: ['Approve', 'View'],
            name: 'Jane Smith',
            userOptions: ['User A', 'User B', 'User C', 'User D', 'User E', 'Add Another'],
        },
        {
            key: '3',
            actionOptions: ['Approve', 'View'],
            name: 'Alice Johnson',
            userOptions: ['User A', 'User B', 'User C', 'User D', 'User E', 'Add Another'],
        },
    ];

    const actionOptions = ['Approve', 'View']
    const columns = [
        {
            title: 'Action',
            dataIndex: 'actionOptions',
            key: 'action',
            render: (_, record) => (
                <Form.Item style={{ marginBottom: 0 }}>
                    <Select defaultValue={record.actionOptions} disabled showSearch>
                        {actionOptions.map((action, idx) => (
                            <Select.Option key={idx} value={action.toLowerCase()}>
                                {action}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Alternate Signatory',
            dataIndex: 'userOptions',
            key: 'user',
            render: (_, record) => (
                // <Form.Item style={{ marginBottom: 0 }}>
                //     <Select defaultValue={record.hockUserId} showSearch disabled>
                //         {/* {userOptions.map((user, idx) => ( */}
                //             <Select.Option  value={record.userOptions}>
                //             {record.userOptions}
                //             </Select.Option>
                //         {/* // ))} */}
                //     </Select>
                // </Form.Item>

                <>
                    {record.approverId && hocUserLists[record.approverId]?.length > 0 && record.actionOptions !== "view" ? (
                        <Form.Item key={record.approverId} name={`hocUser${record.key}`} initialValue={record.hockUserId} style={{ marginBottom: 0 }} >
                            <Select
                                defaultValue={record.hockUserId}
                                disabled
                            >
                                {hocUserLists[record.approverId].map((user, idx) => (
                                    <Select.Option key={idx} value={user.id}>
                                        {user.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    ) : (<></>)
                    }
                </>
            ),
        },
        {
            title: 'Notification',
            dataIndex: 'notificationPermissions',
            key: 'Notification Permissions',
            render: (_, record) => (
                <Form.Item style={{ marginBottom: 0 }}>
                    <Select value={record.notificationPermissions} mode="multiple" placeholder="Select Notification type" showSearch disabled>
                        <Option value="approve_reject">Appprove Reject</Option>
                        <Option value="further_info">Further Info</Option>
                        <Option value="immediate_comment">Immediate Comment</Option>
                        <Option value="consolidate_summary">Consolidate Summary</Option>
                    </Select>
                </Form.Item>
            ),
        },
    ];



    const RenderTeams = () => (
        paginatedItems.map((team) => {
            const menuItems = [
                {
                    label: 'View',
                    key: '1',
                    icon: <EyeOutlined />,
                    onClick: () => {
                        // setSelectedTemplate(null);
                        // setSelectedValue(null);
                        // showEditDrawer();
                        // setSelectedEditTemplate(item);
                        selectTeam(team)

                    },
                },
                {
                    label: 'Remove',
                    key: '3',
                    icon: <DeleteOutlined />,
                    onClick: () => {
                        deleteTeambyId(team)

                    },
                }
            ]
            return (
                <Flex
                    key={team._id}
                    justify='space-between'
                    align='center'
                    gap={16}
                    style={{
                        padding: '16px 24px',
                        // borderBottom: `1px solid ${colorBorder}`,
                        // cursor: 'pointer',
                        marginBottom: '16px',
                        background: colorBgContainer,
                        borderRadius: borderRadiusLG,
                        border: `1px solid ${colorBorder}`
                    }}
                // onClick={() => selectTeam(team)} // Set selected team
                >
                    <Flex justify='space-between' align='flex-start' vertical gap={4}>
                        <Tag color={team.color}>{(team.type.charAt(0).toUpperCase() + team.type.slice(1))}</Tag>
                        <Text strong>{team.name}</Text>
                        <Avatar.Group
                            size={24}
                            max={{
                                count: 2,
                                style: {
                                    color: colorText,
                                    backgroundColor: colorPrimary,
                                    fontSize: 12
                                },
                            }}
                        >
                            {team.members.map((member, index) =>
                                <Avatar
                                    key={index}
                                    size={24}
                                    style={{ backgroundColor: member.color }}
                                    icon={member.icon || null}
                                >
                                    {member.name || null}
                                </Avatar>
                            )}
                        </Avatar.Group>
                    </Flex>
                    <Dropdown
                        menu={{
                            items: menuItems
                        }}
                        trigger={['click']}
                    >
                        <a onClick={(e) => e.preventDefault()}>
                            <Button icon={<MoreOutlined />} />
                        </a>
                    </Dropdown>
                </Flex>
            )
        })
    );

    const renderTeamTable = () => (
        <Card
            bordered={false}
            title={
                <Flex align='center' justify='flex-start' gap={16}>
                    <Button type='text' icon={<CloseOutlined />} onClick={() => setSelectedTeam(null)} />
                    <Text strong>{selectedTeam.name}</Text>
                    <Tag color={selectedTeam.color}>{selectedTeam.type.charAt(0).toUpperCase() + selectedTeam.type.slice(1).toLowerCase()}</Tag>
                </Flex>
            }
            extra={<Button type='primary' icon={<EditOutlined />} onClick={openEditDrawer}> Edit </Button>}
        >
            <Table dataSource={members} columns={columns} pagination={false} />
        </Card>
    );

    return (
        <div>
            <Form layout='vertical'>
                <Row gutter={16}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item label="Circular Type">
                            <Select onChange={(e) => { searchTemplate(e, 110) }}>
                                <Select.Option value="">All</Select.Option>
                                <Select.Option value="parallel">Parallel</Select.Option>
                                <Select.Option value="hierarchy">Hierarchical</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item label="Search Workflow">
                            <Input showSearch onChange={(e) => { searchTemplate(e.target.value, 120) }}></Input>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            {/* <Divider /> */}
            {teamsListLoading ? (<>
                <CommonSkeletonLoader itemCount={2} />
            </>) : (<>
                {selectedTeam ? renderTeamTable() :
                    <>
                        <RenderTeams />
                        {/* {companyTeamsBackup.length > 10 && ( */}
                            <Pagination
                                current={currentPage}
                                pageSize={pageSize}
                                total={companyTeamsBackup.length}
                                onChange={(page) => pagination(page)}
                                style={{ marginTop: "10px" }}
                                align="end"
                            />
                        {/* )} */}
                    </>
                }
            </>)}
            <Drawer
                title="Edit Workflow"
                onClose={onClose}
                open={openEdit}
                width={screens.md ? 'calc(100% - 180px)' : null}
                destroyOnClose={true}
                footer={[
                    <Flex justify='flex-end' align='center' gap='large'>
                        <Button onClick={onClose}>
                            Cancel
                        </Button>
                        <Button type="primary" onClick={() => saveEditTeamData()}>
                            Save
                        </Button>
                    </Flex>
                ]}
            >
                <CreateTeam setTeam={setEditTeam} initialTeam={teamEdit} showTeamNameField={true} drawerClose={drawerclosefun} selectTeam={[selectedTeam]} hocusers={hocUserLists} ref={currentTeamRef}/>
            </Drawer>
        </div>
    );
}
